<template>
  <v-app>
    <Loader :is-visible="loading"></Loader>

    <div
      v-bind:class="{
        'cidades-empreendedoras-header':
          !this.$route.path.includes('diagnostico'),
      }"
      v-if="!this.$route.path.includes('diagnostico') && isAuthenticated"
    >
      <img src="../public/assets/img/sebrae-logo.png" width="100px" />
    </div>
    <MenuMobile :drawer="drawer" @open="(e) => drawer = e" v-if="isAuthenticated"></MenuMobile>

    <v-app-bar
      app
      class="menu a"
      v-bind:class="{
        'degrade-background-sebrae': isSala,
      }"
      v-if="!this.$route.path.includes('diagnostico') && isAuthenticated"
    >
    <div class="teste d-flex align-center menuPage">
      <div class="mobile">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" :style="{color: isCE || isDT?'#fff' : '#000' } "></v-app-bar-nav-icon>
      </div>
     
      <div  class="image" v-if="isSala">
        <selo-logo></selo-logo> 
      </div>
      <img
        v-if="
          !isSala &&
          (isFullAdmin || (groupsConfig.visualizarLogo && config.visualizarLogo))
        "
        :src="logos.logoConstrate"
        width="10%"
        style="cursor: pointer; max-width: 150px"
        @click="$router.push('/cidade')"
        class="image logoMenuCidade"
      >
      </img>

      <div class="desktop">
         <Menu v-if="isAuthenticated" @logout="logout"></Menu>
      </div>
     

      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main
      v-bind:class="{
        logged: !this.$route.path.includes('diagnostico') && isAuthenticated,
      }"
    >
      <router-view />
    </v-main>

    <v-footer
      color="primary"
      class="app-footer"
      v-if="!this.$route.path.includes('diagnostico')"
    >

      <span
        v-if="!isAuthenticated || 
        isFullAdmin || 
            (groupsConfig &&
              config &&
              groupsConfig.visualizarLogo &&
              config.visualizarLogo)
        "
        > {{ title }} - {{ this.$store.state.uf }}</span
      >
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Auth from "@/Auth.js";
import Cookies from "@/components/cookies/cookies";
import { atualUfDefinition, EnumAmbienteTipos } from "./helpers/utils";
import SeloLogo from "./modules/seloLogo/seloLogo.vue";
import Swal from "sweetalert2";
import Menu from "./components/layout/menu.vue";
import MenuMobile from "./components/layout/menuMobile.vue";

export default {
  name: "App",
  components: {
    Loader,
    Cookies,
    SeloLogo,
    Menu,
    MenuMobile,
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "isAdmin",
      "loading",
      "uf",
      "logo",
      "isFullAdmin",
      "isIndicadores",
      "isSala",
      "isAT",
      "isGov",
      "isTur",
      "user",
      "groupsConfig",
      "config",
      "isCE",
      'title',
      'logos',
      "isDT"
    ]),
    isDev() {
      console.log("🚀 ~ isDev ~ atualUfDefinition:", atualUfDefinition)

      return atualUfDefinition.ambient === EnumAmbienteTipos.dev;
    },
    isHlg() {
      return atualUfDefinition.ambient === EnumAmbienteTipos.hlg;
    },
    isProd() {
      return atualUfDefinition.ambient === EnumAmbienteTipos.prod;
    },
  },
  mounted() {
    console.log("isAuthenticated", this.isAuthenticated);
    var token = localStorage.getItem("token") || null;
    var user = JSON.parse(localStorage.getItem("user")) || null;
    var city = localStorage.getItem("city") || null;
    var cityId = localStorage.getItem("cityId") || null;
    var groupsConfig = JSON.parse(localStorage.getItem("groupsConfig")) || null;
    var config = JSON.parse(localStorage.getItem("config")) || null;

    if (city) this.setCityName(city);
    if (cityId) this.setCityId(cityId);
    if (token) {
      this.setToken(token);

      if (user.email === "admin@admin.com.br") {
        user.grupo.verTodosEixos = true;
        user.grupo.visualizaMunicipio = true;
        this.setFullAdmin(true);
      }
    }
    this.setConfigsGlobal({ ...atualUfDefinition, groupsConfig, config, user });
    console.log("🚀 ~ mounted ~ atualUfDefinition:", atualUfDefinition)
    this.bancoProd();
    this.enableInterceptor();
    this.mudaUf();
  },
  data() {
    return {
      drawer: false,
      href: window.location.href,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setUser",
      "setForcedLogout",
      "setCityName",
      "setCityId",
      "setFullAdmin",
      "setConfigsGlobal",
      "setGroupsConfig",
      "setConfig",
    ]),
    bancoProd() {
      if (
        !this.isProd &&
        atualUfDefinition.banco.indexOf("dev") < 0 &&
        atualUfDefinition.banco.indexOf("hlg") < 0
      )
        Swal.fire({
          title: `Cuidado!`,
          text: `Você está usando um banco de produção em um ambiente de teste, não altere ou cadastre nenhum dado!`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Entendi",
        });
    },
    setAmbientName() {
      if (this.isDev) return "Desenvolvimento";
      if (this.isHlg) return "Homologação";
      return;
    },
    getUser() {
      var user = JSON.parse(localStorage.getItem("user"));
      return user;
    },
    getFirstName() {
      if (this.user && this.user.nome) return this.user.nome.split(" ")[0];

      return "";
    },
    mudaUf() {

      setInterval(function () {
        document.documentElement.style.setProperty(
          "--corPrimaria",
          atualUfDefinition.corPrimaria
        );
      }, 100);

      document.title  = this.title 
      document.getElementById("favicon").href = this.logos.logoEncurtada

    },
    enableInterceptor() {
      this.$http.interceptors.request.use(
        (config) => {
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
      this.$http.interceptors.response.use(
        (response) => {
          return response;
        },
        (err) => {
          console.log("err: ", err);

          const status = (err.response && err.response.status) || 0;

          if (status === 401) {
            Auth.setItem("expired", true);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/auth/login");
            });
          }

          return Promise.reject(err);
        }
      );
    },
    logout() {
      this.setForcedLogout(true);
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/auth/login");
      });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";

.menu{
  position: relative !important;
}
@media screen and (max-width: 800px) {
  .logoMenuCidade{
    max-width: 150px !important;
    width: 100%;
  }
}




</style>
